export const redactCharacter = '█'
